import { Provider } from '@angular/core';
import { FLOORI_NAVIGATION_EVENTS } from '@floori-web/models';
import { NavigationEventsService } from './navigation-events.service';

export const navigationStoreProvider: Provider = {
    provide: FLOORI_NAVIGATION_EVENTS,
    useClass: NavigationEventsService,
};
